import styled from 'styled-components';

export const WrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const TextDiv = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const SyncWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
`;
